import React, { useMemo, useCallback } from "react";
import { Form, Select, Modal } from "antd";
import { connect } from "dva";
import { EntityType, dealerStrategiesOptions, transporterStrategiesOptions } from "../constants";
import LinkButton from "./LinkButton";

const StrategyPicker = ({ configPerm, inherited, type, strategyType, onStrategyTypeChange }) => {
  const disabled = useMemo(() => {
    return !configPerm["PricingService.PricingSettings.Update"];
  }, [inherited]);

  const options = useMemo(() => {
    if (type === EntityType.Dealer) {
      return dealerStrategiesOptions;
    } else if (type === EntityType.Transporter) {
      return transporterStrategiesOptions;
    }

    return [];
  }, [type]);

  const handleStrategyChange = useCallback(
    newStrategyType => {
      Modal.confirm({
        title: "Change Pricing Strategy",
        content: "You are about to change the pricing strategy.",
        onOk() {
          onStrategyTypeChange(newStrategyType);
        },
      });
    },
    [onStrategyTypeChange],
  );

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Form layout="vertical">
        <Form.Item label="Strategy">
          <Select disabled={disabled} options={options} value={strategyType} onChange={handleStrategyChange} />
        </Form.Item>
      </Form>
      {inherited && <LinkButton>View group</LinkButton>}
    </div>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(StrategyPicker);
